import { Component, HostListener, input, ChangeDetectionStrategy } from '@angular/core';

import { WidgetWrapperComponent } from '../widget-wrapper/widget-wrapper.component';
import { Widget } from '../../../engine/widget/widget';
import { ToolsActions } from '../../../engine/tools/tools-actions';

@Component({
  selector: 'infl-widget-robot',
  standalone: true,
  imports: [WidgetWrapperComponent],
  templateUrl: './widget-robot.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './widget-robot.component.scss',
})
export class WidgetRobotComponent {
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    document.querySelectorAll('.pupil').forEach((pupil) => {
      const rect = pupil.getBoundingClientRect();
      const x = `${this.minMax(-5, 5, (event.pageX - rect.left) / 100)}px`;
      const y = `${this.minMax(-5, 5, (event.pageY - rect.top) / 100)}px`;
      (pupil as HTMLElement).style.transform = `translate(${x}, ${y})`;
    });
  }

  public widget = input.required<Widget>();
  public actions = [ToolsActions.getCloseAction()];

  private minMax(min: number, max: number, value: number): number {
    return Math.min(max, Math.max(min, value));
  }
}
